export default __webpack_public_path__ + "static/media/06_GIF.ab482eb3.gif";